import React, { useState, useContext, useEffect } from "react";
import {
  Box, Typography, Modal, TextField, Button, MenuItem, IconButton, Alert, Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeContext } from "../../../../context/ThemeContextProvider";
import { createReservation, fetchAllTables } from "../../../../services/pos/Tables"; // ✅ استدعاء الدوال

const ReservationForm = ({ open, onClose, setReservations, onSuccess }) => {
  const { mode } = useContext(ThemeContext);
  const [error, setError] = useState("");
  const [tables, setTables] = useState([]); // حالة للطاولات
  const [form, setForm] = useState({
    table_id: "",
    number_of_people: "",
    reservation_date: "",
    reservation_time: "",
    status: "pending",
    customer_name: "",
    customer_phone1: "",
    email: "",
    note: ""
  });

  useEffect(() => {
    // جلب الطاولات عند فتح المودال
    if (open) {
      fetchAllTables()
        .then((data) => setTables(Array.isArray(data) ? data : []))
        .catch(() => setTables([]));
    }
  }, [open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "number_of_people" && value < 1) return; // منع القيم أقل من 1
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...form,
        number_of_people: form.number_of_people.toString(),
        customer_id: null,
        customer_phone2: "",
        customer_phone3: null,
        customer_address1: "",
        customer_address2: "",
        customer_address3: null,
      };

      const res = await createReservation(payload);
      alert("✅ تم إنشاء الحجز بنجاح");
      setReservations(prev => [...prev, res.data]);
      onSuccess && onSuccess(); // استدعاء onSuccess عند النجاح
      onClose();
    } catch (err) {
      console.error(err);
      setError("❌ فشل في إنشاء الحجز: " + (err.message || "خطأ غير معروف"));
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          right: "50%",
          transform: "translate(50%, -50%)",
          bgcolor: mode === "dark" ? "#1e1e1e" : "#fff",
          boxShadow: 24,
          p: 4,
          width: "600px",
          maxHeight: "90vh",
          borderRadius: "8px",
          color: mode === "dark" ? "#fff" : "#000",
          overflowY: "auto"
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h5" fontWeight="bold">إضافة حجز جديد</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: mode === "dark" ? "#fff" : "#000" }} />
          </IconButton>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            {/* اختيار الطاولة من قائمة منسدلة */}
            <TextField
              select
              fullWidth
              label="اختر الطاولة"
              name="table_id"
              value={form.table_id}
              onChange={handleChange}
              sx={{ mb: 2 }}
            >
              <MenuItem value="">
                <em>اختر الطاولة</em>
              </MenuItem>
              {tables.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {table.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              fullWidth
              label="عدد الأشخاص"
              name="number_of_people"
              type="number"
              value={form.number_of_people}
              onChange={handleChange}
              inputProps={{ min: 1 }} // منع القيم أقل من 1 باستخدام خاصية HTML
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              type="date"
              label="تاريخ الحجز"
              name="reservation_date"
              value={form.reservation_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              type="time"
              label="وقت الحجز"
              name="reservation_time"
              value={form.reservation_time}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              select
              label="الحالة"
              name="status"
              value={form.status}
              onChange={handleChange}
              sx={{ mb: 2 }}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="confirmed">Confirmed</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
            </TextField>
            {/* خانة إضافة ملاحظة */}
            <TextField
              fullWidth
              label="ملاحظة"
              name="note"
              value={form.note}
              onChange={handleChange}
              multiline
              minRows={2}
              sx={{ mb: 2 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="اسم العميل"
              name="customer_name"
              value={form.customer_name}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="رقم الهاتف"
              name="customer_phone1"
              value={form.customer_phone1}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="البريد الإلكتروني"
              name="email"
              value={form.email}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button variant="outlined" onClick={onClose} sx={{ width: "48%" }}>إلغاء</Button>
          <Button variant="contained" onClick={handleSubmit} sx={{ backgroundColor: "#ff85b3", width: "48%" }}>حفظ</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ReservationForm;
